export default {
  DIGITS_RE: /\B(?=(\d{3})+(?!\d))/g,
  AVOID_WHITESPACE_PATTERN: /[^ ]/,
  NAME_PATTERN: /^[0-9a-zA-Z-_]+$/,
  SUBNET: /^(.*?)\/(\d{1,2})$/,
  IP_ADDRESS:
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|[0-5][0-9]|6[0-4]))?$/,
  NOT_A_NUMBER: /[^0-9]/g,
  PATTERN_PATH: "^(/[^/]+){0,}/?$",
  PATTERN_DOMAIN:
    /^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,12}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,12})$/,
  PATTERN_NUMBER: /^[0-9]*$/,
  PATTERN_IPV4:
    "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\\/([0-9]|[1-2][0-9]|3[0-2]))?$",
  URL_PATTERN: /^https?:\/\//,
  HTTP_STATUS_CODE: /^[0-9-,]+$/,
  PATTERN_TRIM: /^(?!\s)(?!.*\s$).+$/,
  PATTERN_IPV6:
    /^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){1,6}:([0-9A-Fa-f]{1,4}|:){1,6}))$|^((([0-9A-Fa-f]{1,4}:){1,5}(:[0-9A-Fa-f]{1,4}|:){1,5})|(([0-9A-Fa-f]{1,4}:){1,4}(:[0-9A-Fa-f]{1,4}|:){1,6}))$|^((([0-9A-Fa-f]{1,4}:){1,3}(:[0-9A-Fa-f]{1,4}|:){1,7})|(([0-9A-Fa-f]{1,4}:){1,2}(:[0-9A-Fa-f]{1,4}|:){1,8}))$|^((([0-9A-Fa-f]{1,4}:){1}(:[0-9A-Fa-f]{1,4}|:){1,9})|(:(:[0-9A-Fa-f]{1,4}){1,7}))$/,
};
